<template>
  	<el-container>
		<app-sidebar></app-sidebar>
		<el-container direction="vertical">
			<app-content></app-content>
		</el-container>
	</el-container>
</template>

<script>
	import { FECTH_DASHBOARD, FECTH_AUTH } from "@/store/actions.type";

	import SideBar from '@/components/Dashboard/Sidebar'
	import TopNavbar from '@/components/Dashboard/TopNavbar'
	import ContentFooter from '@/components/Dashboard/ContentFooter'
	import DashboardContent from '@/components/Dashboard/Content'


	export default {
		name: 'Dashboard',
		created () {
			this.user()
			this.$root.$on('msgSuccess', (text) => {this.msgSuccess(text)})
			this.$root.$on('msgError', (text) => {this.msgError(text)})
			this.$root.$on('isConnect', () => {this.isConnect()})
		},
		components: {
			'app-sidebar': SideBar,
			'app-navbar': TopNavbar,
			'app-content': DashboardContent,
			'app-footer': ContentFooter
		},
		methods: {
			user() {
				let obj = JSON.parse(localStorage.getItem('analiticauser'));
				this.$store.dispatch(FECTH_AUTH, obj )
			},
			msgSuccess(text){
				this.$notify({
					title: 'Success',
					message: text,
					type: 'success',
					position: 'top-right'                    
				});
			},
			msgError(text){
				this.$notify.error({
					title: 'Error',
					message: text,
					position: 'top-right'
				});
			},
			isConnect(){
				console.log('aa')
                if(!localStorage.getItem('analiticatoken')){
                    this.msgError('Su sesión ha caducado.')
                    setTimeout(() => { this.$router.go('/login') }, 1000);
                    return false
                }
                return true
            }
		}
	}

</script>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue